<div class="container flex w-full flex-col items-center">
  <rd-shared-breadcrumb
    class="ml-4 self-start lg:ml-0"
    [displayModeDesktop]="'stacked'"
    [displayModeMobile]="'stacked'"
    [breadcrumbText]="'redeem_cash_v2.back_to_checkout' | translate"
    [loading]="false"
    [redirectURL]="'/redeem_cash/checkout'">
  </rd-shared-breadcrumb>

  <div class="desktop-container w-full px-4 lg:px-0">
    <div
      class="max-width info rounded-md flex w-full justify-center justify-between px-4 py-5 lg:mx-0">
      <div class="flex flex-col justify-around">
        <p class="typo-text-mobile lg:typo-text-desktop">
          {{ 'enrollment.selected_redemption' | translate }}
        </p>
        <p
          class="title typo-text-emphasis-1-mobile lg:typo-text-emphasis-1-desktop"
          *ngIf="loyaltyProgram$ | async as lp">
          {{ lp.loyaltyCurrency?.shortName
          }}{{ (checkoutFormData$ | async)?.targetAmount }} {{ lp.shortName }}
        </p>
      </div>
    </div>
    <h1 class="title self-start typo-heading-3-desktop">
      {{ 'enrollment.form.title' | translate }}
    </h1>
    <form (ngSubmit)="submit()" class="flex flex-col">
      <rd-anz-enrollment-form></rd-anz-enrollment-form>
      <rd-shared-button
        *ngIf="(formType$ | async) !== enrollmentFormType.NoCreditCard"
        class="submit-button my-6 self-center"
        [dataTestid]="'anz-rc-enrollment-button-review'"
        [isDisabled]="disableButtonState$ | async"
        buttonText="Review"
        buttonTheme="primary"
        buttonType="submit"></rd-shared-button>
    </form>
  </div>
</div>
